/**
 * Post-import link registry bootstrap for legacy importService path.
 */
export async function finalizeImportedTripLinkRegistry(userId, tripId, importData) {
  const { linkRegistryConfigService } = await import('@trip-planner-monorepo/shared');
  return linkRegistryConfigService.finalizeImportLinkRegistry(userId, tripId, {
    linkRegistryMeta: importData?._meta?.linkRegistry,
    hasImportedLinks: Boolean(importData?.links?.length)
  });
}
